export const SET_INITIAL_DATA = "x/welcome/SET_INITIAL_DATA";
export const setInitialData = data => ({
    type: SET_INITIAL_DATA,
    payload: data,
});